<template>
  <div class="custom-wrapper" :class="{active: visible || visible2 || visible3}">
    <div class="position: relative;">
      <!-- .custom-text-type-1 === ctt1 -->
      <popper :show-popper="visible" @close="visible=false" placement="right-start" :index="index">
        <div class="ctt1" @click.prevent="setVisible()">
          <div class="ctt1-box custom-item">
            <!-- 内容 -->
            <div style="padding: 10px">
              <div
                v-if="!textModal.content"
                style="background:#91c0ec;color:#fff;text-align:center;"
              >点击编辑文本</div>
              <pre
                :style="{'color':textModal.color,'font-size':textModal.fontSize,'text-align':textModal.position,'width':'100%','line-height': '2em', 'word-break': 'break-all', 'white-space': 'pre-line'}"
                v-else
              >{{textModal.content}}</pre>
            </div>

            <!-- 关闭按钮 -->
            <i class="icon iconfont icon-close-c custom-close" @click="close()"></i>
          </div>
        </div>
        <div slot="content" class="ctt1-poptip">
          <div class="ctt1p-title">文本设置</div>

          <!-- 设置内容 -->
          <div class="ctt1p-content">
            <Form ref="formInline" :model="formInline" style="width:90%;">
              <FormItem label="文本内容:">
                <Input
                  style="width:300px"
                  type="textarea"
                  :rows="4"
                  v-model="textModal.content"
                  placeholder="请输入文本内容"
                />
              </FormItem>
              <FormItem label="字体大小:">
                <RadioGroup v-model="formInline.fontSize" type="button" @on-change="changefontSize">
                  <Radio label="大"></Radio>
                  <Radio label="中"></Radio>
                  <Radio label="小"></Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="文本颜色:">
                <ColorPicker v-model="textModal.color" />
                <Button style="margin-left:20px;" @click="textModal.color = '#000'">重置</Button>
              </FormItem>
              <FormItem label="显示位置:">
                <RadioGroup
                  v-model="formInline.positionValue"
                  type="button"
                  @on-change="changePosition"
                >
                  <Radio label="居左显示"></Radio>
                  <Radio label="居中显示"></Radio>
                  <Radio label="居右显示"></Radio>
                </RadioGroup>
              </FormItem>
            </Form>
            <div style="text-align:right;">
              <Button type="primary" @click.prevent="setVisible()">暂存</Button>
            </div>
          </div>

          <!-- <a @click="visible=false">关闭</a> -->
        </div>
      </popper>
      <!-- 上方增加键 -->
      <Poptip
        v-model="visible2"
        placement="right-start"
        width="411"
        class="custom-add-wrapper z-top"
      >
        <img src="@/assets/img/custom/add.png" />
        <div slot="content" class="ctt1-poptip">
          <div class="ct-components">
            <div class="ctc-title">新增组件</div>
            <div class="ctc-group" v-if="commmonType===1">
              <div
                class="ctc-item"
                v-for="(item, index) in commmonArr"
                :key="'commmon-' + index"
                @click="add(item, 'top')"
              >
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
            <div class="ctc-group" v-if="commmonType===2">
              <div
                class="ctc-item"
                v-for="(item, index) in commmonArr2"
                :key="'commmon-' + index"
                @click="add(item, 'top')"
              >
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </Poptip>
      <!-- 下方增加键 -->
      <Poptip
        v-model="visible3"
        placement="right-start"
        width="411"
        class="custom-add-wrapper z-bottom"
      >
        <img src="@/assets/img/custom/add.png" />
        <div slot="content" class="ctt1-poptip">
          <div class="ct-components">
            <div class="ctc-title">新增组件</div>
            <div class="ctc-group" v-if="commmonType===1">
              <div
                class="ctc-item"
                v-for="(item, index) in commmonArr"
                :key="'commmon-' + index"
                @click="add(item, 'bottom')"
              >
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
            <div class="ctc-group" v-if="commmonType===2">
              <div
                class="ctc-item"
                v-for="(item, index) in commmonArr2"
                :key="'commmon-' + index"
                @click="add(item, 'bottom')"
              >
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </Poptip>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import popper from "@components/vue-popper/VuePopper.vue";

export default {
  // 文本类型 1
  name: "custom-text-type-1",
  model: {
    prop: "textModal",
    event: "sendTextModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    textModal: {
      type: Object,
      default: function() {
        return {
          type: 1, // 文本类型 暂时只有 1
          content: "文本内容", // 文本内容
          fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
          color: "#000", // 文字颜色 默认黑色
          position: "left" // 文本对齐格式
        };
      }
    },
    info: {
      type: Object,
      default: {
        type: 1, // 文本类型 暂时只有 1
        content: "", // 文本内容
        fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
        color: "#000", // 文字颜色 默认黑色
        position: "left" // 文本对齐格式
      }
    },
    commmonType: {
      // 通用添加组件的列表   1：所有列表   2：筛选列表
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      visible: false,
      visible2: false,
      visible3: false,

      commmonArr: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        },
        {
          title: "标题",
          icon: "icon-biaoti",
          type: "title",
          componentName: "customTitle",
          config: {
            type: 1, // 标题类型 暂时只有 1
            content: "",
            position: "left", // 文本对齐格式
            padding: "12px", // 标题的边距
            fontSize: "12px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色
            link: {
              type: "3",
              value: ""
            }
          }
        },
        {
          title: "链接",
          icon: "icon-link",
          type: "link",
          componentName: "customLink",
          config: [
            {
              type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
              name: "",
              url: ""
            }
          ]
        },
        {
          title: "产品搜索",
          icon: "icon-sousuo",
          type: "search",
          componentName: "customSearch",
          config: {
            type: 1, // 搜索类型 暂时只有 1
            words: ["热词1", "热词2"],
            style: "circular", // 搜索外边框样式 （圆 \ 方）
            position: "left", // 文本对齐格式
            color: "#ccc",
            background: "#f5f5f5",
            borderColor: "#91c0ec"
          }
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        }
      ],
      commmonArr2: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        }
      ],

      formInline: {
        fontSize: "大",
        positionValue: "居左显示"
      }
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      if (val !== this.index) {
        this.visible = false;
      } else {
        this.visible = true;
      }
    }
  },
  components: {
    popper
  },
  computed: {
    ...mapGetters({
      activeIndex: "customComponentModule/getActiveIndex"
    })
  },
  created() {
    if (this.index === this.activeIndex) {
      this.visible = true;
    }
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customComponentModule/setActiveIndex"
    }),
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    popperHide() {},
    add(item, index) {
      // top 表示在上面添加  bottom表示下面添加
      let idx = this.index;
      if (index === "bottom") {
        idx = this.index + 1;
      }
      this.$emit("add", item, idx);
      this.visible = false;
      this.visible2 = false;
      this.visible3 = false;
      
      
    },
    close() {
      this.$emit("close");
    },
    changefontSize(value) {
      if (value === "大") {
        this.textModal.fontSize = "16px";
      }
      if (value === "中") {
        this.textModal.fontSize = "14px";
      }
      if (value === "小") {
        this.textModal.fontSize = "12px";
      }
    },
    changePosition(value) {
      if (value === "居左显示") {
        this.textModal.position = "left";
      }
      if (value === "居中显示") {
        this.textModal.position = "center";
      }
      if (value === "居右显示") {
        this.textModal.position = "right";
      }
    },
    init() {
      if (this.textModal && this.textModal.fontSize) {
        switch (this.textModal.fontSize) {
          case "16px":
            this.formInline.fontSize = "大";
            break;
          case "14px":
            this.formInline.fontSize = "中";
            break;
          case "12px":
            this.formInline.fontSize = "小";
            break;
        }
      }
      if (this.textModal && this.textModal.position) {
        switch (this.textModal.position) {
          case "left":
            this.formInline.positionValue = "居左显示";
            break;
          case "center":
            this.formInline.positionValue = "居中显示";
            break;
          case "right":
            this.formInline.positionValue = "居右显示";
            break;
        }
      }
    }
  },
  mounted() {
    this.init();
    if (this.index === 0) {
      this.visible = true;
      this.setActiveIndex(this.index);
    }
  }
};
</script>

<style lang="scss">
.custom-wrapper {
  .ivu-select-dropdown {
    width: 300px;
    left: 0;
  }
}
</style>
<style scoped lang="scss">
.ctt1 {
  width: 100%;
  &-box {
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  &-poptip {
    min-height: 60px;
    .ctt1p {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-content {
        padding: 20px 20px;
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
</style>
